import { Component, computed, inject, Input, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomAssessmentsService } from '../../services/custom-assessments.service';
import {
  Assessment,
  CustomAssessment,
  CustomData,
  CustomFile,
  initDataCustom,
  TwoHandsNumberDataSet,
} from '../../services/model';

import { CommonModule, Location, ViewportScroller } from '@angular/common';
import { DocumentReference } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { from } from 'rxjs';
import { FileUploadComponent } from '../../components/file-upload/file-upload.component';
import { NavigationComponent } from '../../components/navigation/navigation.component';
import { AssessmentsService } from '../../services/assessments.service';
import { FilesService } from '../../services/file.service';
import { getDateIsoString, getDateIsoStringPlus1Minute } from '../../services/util.functions';
import { AssessmentBaseComponent } from '../assessment-base/assessment-base.component';
import { DynamicTableInputComponent } from '../dynamic-table-input/dynamic-table-input.component';

@Component({
  selector: 'app-custom-assessment',
  standalone: true,
  imports: [
    DynamicTableInputComponent,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatChipsModule,
    MatSelectModule,
    MatTableModule,
    RouterModule,
    MatTooltipModule,
    MatIconModule,
    FileUploadComponent,
    NavigationComponent,
  ],
  templateUrl: './custom-assessment.component.html',
  styleUrl: './custom-assessment.component.scss',
})
export class CustomAssessmentComponent extends AssessmentBaseComponent implements OnInit {
  location: Location = inject(Location);
  public filesService: FilesService = inject(FilesService);
  private assessmentService: AssessmentsService = inject(AssessmentsService);
  @Input() assessmentId: string | undefined;
  customAssessmentsService = inject(CustomAssessmentsService);

  private scroller: ViewportScroller = inject(ViewportScroller);

  customAssessmentList: Signal<CustomAssessment[]> = this.customAssessmentsService.customAssessmentList;
  $routeParams = toSignal(this.route.queryParamMap);
  $customAssessment: Signal<CustomAssessment | undefined> = computed(() => {
    const id: number = Number.parseFloat(this.$routeParams()?.get('id') ?? '-1');
    const list = this.customAssessmentList();

    console.log('customAssessment signal', { id, list });
    if (id > -1 && list) {
      const item = list.filter(item => item.id === id)[0];
      console.log('item', item);
      return item;
    } else {
      return undefined;
    }
  });

  fileList = from(this.filesService.getFileList(''));

  assessmentData: WritableSignal<CustomData | undefined> = signal<CustomData | undefined>(undefined);
  assessmentDataNew: CustomData = JSON.parse(JSON.stringify(initDataCustom));
  hasError = signal({
    custom: false,
  });

  private fb: FormBuilder = inject(FormBuilder);
  form: FormGroup = this.fb.group({
    assessmentTime: [getDateIsoStringPlus1Minute(), Validators.required],
    note: [''],
  });

  constructor(public override dialog: MatDialog) {
    super(dialog);
    this.customAssessmentsService.getCustomAssessments();
  }

  ngOnInit() {
    this.scroller.scrollToPosition([0, 0]);

    this.route.queryParamMap.subscribe(params => {
      const id = params.get('id');

      console.log('CustomAssessmentComponent', id);
    });

    if (this.assessmentId) {
      this.assessmentService.getAssessment(this.assessmentId).then(data => {
        const customData: CustomData = data.data as CustomData;
        this.assessmentData.set(customData);
        const date = getDateIsoString(new Date(data.dateIso));
        this.form.controls['assessmentTime'].patchValue(date);

        const note = data.note;
        // @TODO hier machen wir die Migration rein!!!
        // also aus allen sub-tests die note-Eingaben holen und hier reinschreiben
        this.form.controls['note'].patchValue(note);

        this.assessmentDataNew = JSON.parse(JSON.stringify(this.assessmentData()));
      });
    } else {
      const initData = { custom: { ...initDataCustom.custom, title: this.$customAssessment()?.shortName } };
      this.assessmentData.set(initData);
      this.assessmentDataNew = JSON.parse(JSON.stringify(this.assessmentData()));
    }
  }

  onCustomData(data: { data: Array<TwoHandsNumberDataSet>; note: string; hasError: boolean }) {
    this.assessmentDataNew.custom.data = data.data;
    this.assessmentDataNew.custom.note = data.note;
    this.hasError.update(current => ({
      ...current,
      custom: data.hasError,
    }));
  }
  onChangeFiles(files: CustomFile[]) {
    console.log('onChangeFiles', files);

    this.assessmentDataNew.custom.files = files;
  }

  onSave() {
    if (this.hasError().custom) {
      return;
    }
    const inputdata: Array<TwoHandsNumberDataSet> = this.assessmentDataNew.custom.data;
    const schaedigungLeft = inputdata[0].valueLeft ? 100 - inputdata[0].valueLeft : undefined;
    const schaedigungRight = inputdata[0].valueRight ? 100 - inputdata[0].valueRight : undefined;

    const data: Assessment = {
      type: 'CUSTOM',
      customId: this.$customAssessment()?.id,
      dateIso: this.form.controls['assessmentTime'].value,
      note: this.form.controls['note'].value ?? '',
      data: this.assessmentDataNew,
    };

    // Nur Felder hinzufügen, die definiert sind (sonst flennt firebase: Function addDoc() called with invalid data. Unsupported field value: undefined (found in field scorePercentageRight in document)
    if (schaedigungLeft !== undefined) {
      data.scorePercentageLeft = schaedigungLeft;
    }
    if (schaedigungRight !== undefined) {
      data.scorePercentageRight = schaedigungRight;
    }

    console.log('save', { data });

    if (this.assessmentId) {
      this.assessmentService.updateAssessment(this.assessmentId, data).then(res => {
        this.router.navigate(['../../../reports/assessments'], {
          relativeTo: this.route,
          queryParams: { cId: this.$customAssessment()?.id, dId: this.assessmentId },
        });
      });
    } else {
      this.assessmentService.createAssessment(data).then((docRef: DocumentReference) => {
        this.router.navigate(['../../reports/assessments'], {
          relativeTo: this.route,
          queryParams: { cId: this.$customAssessment()?.id, dId: docRef.id },
        });
      });
    }
  }

  onNavigateBack() {
    if (this.assessmentId) {
      // this.router.navigate(['../../../reports/assessments'], { relativeTo: this.route });
      this.location.back();
    } else {
      // this.router.navigate(['../../reports/assessments'], { relativeTo: this.route });
      this.router.navigate(['../../assessments/new'], { relativeTo: this.route });
    }
  }
}
